import React, { useEffect } from 'react';
import aboutImg from '../../images/about.png'
import './About.css'
import AOS from 'aos';
import 'aos/dist/aos.css';

const About = () => {
    useEffect(() => {
        AOS.init({
            duration: 600,
        })
    }, [])
    return (
        <div id="about" style={{ background: "#2B3436", padding: "50px 0px" }}>
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <div className='about-image-border'>
                            <img src={aboutImg} alt="about-img" class='pe-5 img-fluid about-img' />
                            <div className='about-img-border'></div>
                        </div>
                    </div>
                    <div
                        data-aos="fade-right"
                        class="col-md-6">
                        <h2 className="text-white pb-3 pt-5 about-section-border">About Me</h2>
                        <p className="text-white pe-4 lh-lg">Hi I am Motiur Rahman. I am a junior web developer. I love coding. Everyday I try to improve myself to learn something new. I love to solve Error.</p>
                        <p className="text-white pe-4 lh-lg">100% sincere, serious, hard-working, dedicated, committed, and honest.</p>
                        {/* contact info */}
                        <div className="py-2">
                            <p className="text-white my-1"><i class="fas fa-phone-alt me-1"></i> +8801980605303</p>
                            <p className="text-white my-1"><i class="fas fa-envelope me-2"></i> motiurrahmanmisu@gmail.com</p>
                        </div>
                        {/* social link */}
                        <div className="social-icon mt-2">
                            <a href="https://github.com/motiurdev" target="_blank" rel="noreferrer">
                                <i class="fab fa-github-square fa-2x"></i>
                            </a>
                            <a href="https://www.linkedin.com/in/motiur-rahman-misu/" target="_blank" rel="noreferrer">
                                <i class="fab fa-linkedin fa-2x"></i>
                            </a>
                            <a href="https://www.facebook.com/motiurrahmanmisu" target="_blank" rel="noreferrer">
                                <i class="fab fa-facebook-square fa-2x"></i>
                            </a>
                            <a href="https://motiurdev.xyz/" target="_blank" rel="noreferrer">
                                <i class="fas fa-globe fa-2x"></i>
                            </a>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;